import React from "react"
import { Button, Card, CardBody } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"

const TransferToFacilityListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onChangeRowNumber,
  selectedIds,
  onCheckboxChange,
  onSelectAll,
  onApprove,
  onReject,
}) => {
  const pendingItems = data?.data?.filter(item => item.status === "Pending") || []
  const allPendingSelected =
    pendingItems.length > 0 &&
    pendingItems.every(item => selectedIds.includes(item.id))

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <CustomHeaderTitle
              loading={loading}
              // title={"Transfer Requests"}
              rowCount={false}
              onChangeRowNumber={onChangeRowNumber}
              lgColumn={4}
            />
            <div className="d-flex gap-2">
              <Button
                color="success"
                onClick={onApprove}
                disabled={selectedIds.length === 0 || loading}
              >
                Approve Selected
              </Button>
              <Button
                color="danger"
                onClick={onReject}
                disabled={selectedIds.length === 0 || loading}
              >
                Reject Selected
              </Button>
            </div>
          </div>

          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={true}
            onParentCheckChange={onSelectAll}
            headers={[
              "SN",
              "IP ACCOUNT",
              "BATCH NUMBER",
              "ITEM",
              "QUANTITY",
              "PROVINCE",
              "FACILITY",
              "REQUESTED BY",
              "STATUS",
              "REQUEST DATE",
              "TRANSFER DATE",
              "SELECT",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(transfer, index) => {
              const isChecked = selectedIds.includes(transfer.id)
              const isPending = transfer.status === "Pending"

              return (
                <tr key={index}>
                  <th scope="row">{data?.meta?.from + index}</th>  
                  <td>{transfer?.user?.email || "-"}</td>
                  <td>{transfer.province_in?.batch_number || "-"}</td>
                  <td>
                    {transfer.province_in?.item?.ip_item_description || "-"}
                  </td>
                  <td>{transfer.qty}</td>
                  <td>{transfer.province?.province || "-"}</td>
                  <td>
                    {transfer.facility?.facility_name || "-"}
                    {transfer.facility?.facility_code &&
                      ` (${transfer.facility.facility_code})`}
                  </td>
                  <td>{transfer.user?.name || "-"}</td>
                  <td>
                    <span
                      className={`badge ${
                        transfer.status === "Approved"
                          ? "badge-soft-success"
                          : transfer.status === "Rejected"
                          ? "badge-soft-danger"
                          : "badge-soft-warning"
                      }`}
                    >
                      {transfer.status}
                    </span>
                  </td>
                  <td>
                    {transfer.created_at
                      ? new Date(transfer.created_at).toLocaleDateString()
                      : "-"}
                  </td>
                  <td>
                    {transfer.date
                      ? new Date(transfer.date).toLocaleDateString()
                      : "-"}
                  </td>
                  <td>
                    {isPending && (
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={e => onCheckboxChange(transfer.id, e.target.checked)}
                      />
                    )}
                  </td>
                </tr>
              )
            }}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default TransferToFacilityListComponent
